<template>
<div>
<section v-for="artigo in json" v-bind:key="artigo.id">
    <section id="imagem-noticia" v-bind:style="{ 'background-image': 'url(' + artigo.img + ')' }"></section>
    <section id="noticia" v-bind:class="artigo.categoria +'-noticia'">
        <img id="autor" v-bind:src="`//www.habbo.com.br/habbo-imaging/avatarimage?hb=image&user=${artigo.autor}&headonly=0&direction=4&head_direction=3&action=crr=6&gesture=sml&size=l`">
      <h1 v-bind:class="artigo.categoria +'-texto'">
        {{ artigo.titulo }}
      </h1>
      <h2>
       {{ artigo.descricao }}
      </h2>
      <span>
      <img src="//www.lefrank.com.br/img/icons/v20_6.gif" /> {{ artigo.data }}
</span><br>
      <span>Escrito por <b v-bind:class="artigo.categoria +'-texto'">{{ artigo.autor }}</b> na coluna de <b v-bind:class="artigo.categoria +'-texto'">{{ artigo.categoria }}</b>.</span>
      <section class="divisor"></section>
      <section id="texto">
        <div v-html="artigo.texto"></div>
      </section>
      <section class="divisor"></section>
    </section>
</section>
</div>
</template>

<script>
export default {
  name: "Artigo",
  data: () => ({
    json: {}
  }),
  created: function() {
    let id = this.$route.params.id;
    fetch(`https://api.lefrank.com.br/artigos?id=${id}`).then((response) => {
      return response.json().then((json) => {
        this.json = json
      })
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#botao-voltar {
  width: 30px;
  height: 30px;
  background-color: white;
  box-shadow: 0 2px 2px rgba(0,0,0,0.2);
  position: fixed;
  border-radius: 50px;
  z-index: 77;
  padding: 10px;
  background-color: white;
  border: 1px solid rgba(0,0,0,0.2);
  color: white;
  background-size: 25px;
  background-repeat: no-repeat;
  background-position: 13px;
  margin: 10px;
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

#imagem-noticia {
  width: inherit;
  height: 300px;
  background-size: cover;
  background-position: center;
}

#noticia {
  width: inherit;
  padding: 15px 10px;
  margin-top: -50px;
  border-radius: 50px 50px 0 0;
  background-color: white;
  box-shadow: 0 -1px 1px rgba(0,0,0,0.3);
}

#noticia #autor {
  float: right;
  height: 150px;
}

#noticia h1 {
  width: inherit;
  margin: 10px 15px 2.5px 15px;
  font-family: 'Krub', sans-serif;
  font-size: 1.375rem;
  font-weight: 700;
}

#noticia h2 {
  color: rgba(0,0,0,0.8);
  width: inherit;
  margin: 2.5px 15px;
  font-family: 'Krub', sans-serif;
  font-size: 1rem;
  font-weight: 300;
}

#noticia span {
  color: rgba(0,0,0,0.8);
  width: inherit;
  margin: 0 15px;
  font-family: 'Krub', sans-serif;
  font-size: 0.75rem;
  font-weight: 200;
}

.divisor {
  width: inherit;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  margin: 20px 0;
}

#noticia #texto {
  width: inherit;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-align: justify;
  font-size: 1rem;
  margin: 0 15px;
}

#noticia #texto p {
  margin: 0;
  padding: 0;
  line-height: 1,5px;
}

#noticia #texto span {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-align: justify;
  font-size: 1rem;
  color: black;
  margin: 0;
  padding: 0;
  line-height: 1,5px;
}

#noticia #texto img {
  max-width: 90% !important;
  height: auto !important;
  border-radius: 8px !important;
}
</style>
